import { render, staticRenderFns } from "./ConfirmRemoveDefault.vue?vue&type=template&id=23a490ec"
import script from "./ConfirmRemoveDefault.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports